import {chains} from 'generated/chains';

import {APP_CONFIG} from 'app-config';

import {
  CosmosChainId,
  CosmosChainInfo,
  CosmosAssetInfo,
  ChainInfoDefinition,
} from './cosmos.types';

//

chains.forEach(chain => {
  if (chain.chainId.includes('elys')) {
    if (APP_CONFIG.REST_URL) {
      (
        chain as {
          restURL: string;
        }
      ).restURL = APP_CONFIG.REST_URL;
    }

    if (APP_CONFIG.RPC_URL) {
      (
        chain as {
          rpcURL: string;
        }
      ).rpcURL = APP_CONFIG.RPC_URL;
    }
  }
});

//

export const COSMOS_CHAINS_LIST = [
  ...chains,
] as const satisfies readonly ChainInfoDefinition[];

export const COSMOS_CHAINS = COSMOS_CHAINS_LIST.reduce(
  (chains, chain) => {
    chains[chain.chainId] = chain as unknown as CosmosChainInfo;
    return chains;
  },
  {} as Record<CosmosChainId, CosmosChainInfo>,
);

export const COSMOS_ASSETS = Object.values(COSMOS_CHAINS_LIST)
  .map(chain => {
    return chain.currencies.map(currency => {
      return {
        chainId: chain.chainId,
        chainType: chain.type,
        chainNetwork: chain.chainNetwork,
        ...currency,
      };
    });
  })
  .flat()
  .filter(
    chain => chain.chainNetwork === APP_CONFIG.CHAIN_NETWORK,
  ) as CosmosAssetInfo[];

export const COSMOS_ASSETS_BY_DENOM = COSMOS_ASSETS.reduce<
  Record<string, CosmosAssetInfo>
>((map, asset) => {
  map[asset.coinMinimalDenom] = asset;
  return map;
}, {});

//
